module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-wrap"
  }, [_c('div', {
    staticClass: "form-list py-2"
  }, [_c('div', {
    staticClass: "row form-description-area"
  }, [_c('p', {
    staticClass: "col-12 px-4"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[3][2]",
      "replaceData": {
        email: _vm.email
      },
      "isHtml": true
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "col-12 px-4 text-danger"
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[3][3]",
      "isHtml": true
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "col-12 px-4"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[3][4]",
      "isHtml": true
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.input.confirmation_code.$error
    }
  }, [_c('label', {
    staticClass: "col-6 col-form-label"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[3][5]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.confirmation_code),
      expression: "input.confirmation_code"
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "123456"
    },
    domProps: {
      "value": (_vm.input.confirmation_code)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.confirmation_code.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.confirmation_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 pl-4 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.confirmation_code,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error[3][1]"
    }
  })], 1), _vm._v(" "), _c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.confirmation_code,
      "type": "number"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error[3][2]"
    }
  })], 1), _vm._v(" "), _c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.confirmation_code,
      "type": "numberLength"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error[3][3]"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('button', {
    staticClass: "btn w-100 btn-lg btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.tryForm
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[3][6]"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ec1d4802!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/partials/Verify/PageForm.vue
// module id = 739
// module chunks = 0